module.exports = __webpack_public_path__ + "img/extensionagentproc.30b089e9.svg";